import { createAction, props } from '@ngrx/store';
import { AppError } from 'src/app/shared/utils';
import { ListDashboardDto } from '../../../services/api.services';

export const setVisible = createAction(
  '[Welcome] Set Visible',
  props<{ visible: boolean }>()
);


export const loadDashboards = createAction(
  '[Welcome] Load Dashboards'
);

export const loadDashboardsSuccess = createAction(
  '[Welcome] Load Dashboards Success',
  props<{ dashboards: ListDashboardDto[] }>()
);

export const loadDashboardsFailure = createAction(
  '[Welcome] Load Dashboards Failure',
  props<{ error: AppError }>()
);


export const setSelectedDashboard = createAction(
  '[Welcome] Set Selected Dashboard',
  props<{ dashboardId: number }>()
);


export const addDashboardToHome = createAction(
  '[Welcome] Add Dashboard To Home',
  props<{ dashboardId: number }>()
);

export const addDashboardToHomeSuccess = createAction(
  '[Welcome] Add Dashboard To Home Success',
  props<{ dashboardId: number }>()
);

export const addDashboardToHomeFailure = createAction(
  '[Welcome] Add Dashboard To Home Failure',
  props<{ error: AppError }>()
);


export const setFirstHomeDashboardSelected = createAction(
  '[Welcome] Set First Home Dashboard Selected',
  props<{ dashboardId: number }>()
);

export const setFirstHomeDashboardSelectedSuccess = createAction(
  '[Welcome] Set First Home Dashboard Selected Success',
  props<{ dashboardId: number }>()
);

export const setFirstHomeDashboardSelectedFailure = createAction(
  '[Welcome] Set First Home Dashboard Selected Failure',
  props<{ error: AppError }>()
);


export const adminHideDialog = createAction(
  '[Welcome] Admin Hide Dialog'
);
